import { useCallback } from 'react';

// @ts-expect-error - JS module without type declarations
import { useTemplateFoundPopup } from 'src/components/TemplateFoundPopup';
import { GENERATION_TOOL } from 'src/data/generationTool';
import * as ls from 'src/lib/localData';
// @ts-expect-error - useMultiPromptTemplateActions module without type declarations
import { useMultiPromptTemplateActions } from 'src/store';

const toSnakeCaseKey = (value: string) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');

interface MultiPromptTemplate {
  name: string;
  generationTool: string;
}

interface MultiPromptTemplateActions {
  getMultiPromptReleasedTemplates: () => MultiPromptTemplate[];
}

interface RequestClassifiedToolParams {
  classifiedTool: string;
  inPopupMode: boolean;
  multiPromptTemplateActions: MultiPromptTemplateActions;
}

export const useRequestClassifiedToolUserApproval = () => {
  const openTemplateFoundPopup = useTemplateFoundPopup();
  const multiPromptTemplateActions = useMultiPromptTemplateActions();

  const alignTool = useCallback(
    // Using string instead if GenerationTool type since classifiedTool has a custom structure, and sometimes it returns the template as prefix/suffix
    (classifiedTool: string) => {
      if (classifiedTool === GENERATION_TOOL.blogDescription) {
        return { generationTool: GENERATION_TOOL.blogDescription, name: 'Blog post' };
      }
      const templates = multiPromptTemplateActions.getMultiPromptReleasedTemplates();

      return templates.find(
        (template: MultiPromptTemplate) => toSnakeCaseKey(template.name) === classifiedTool
      );
    },
    [multiPromptTemplateActions]
  );

  return useCallback(
    async ({ classifiedTool, inPopupMode }: RequestClassifiedToolParams) => {
      // If user has already chosen to not show the popup, continue with the prompt
      if (ls.templateFoundPopupDoNotShowAgain.read()) {
        return;
      }

      const alignedTool = alignTool(classifiedTool);

      // Request user's approval for the classified tool
      const result = await openTemplateFoundPopup({
        generationTool: alignedTool,
        displayBackButton: inPopupMode,
        templateName: alignedTool?.name,
      });
      // Save user's choice
      if (result?.dontShowAgain) {
        ls.templateFoundPopupDoNotShowAgain.write(true);
      }
      if (!result?.generationTool) {
        return;
      }
      return result;
    },
    [openTemplateFoundPopup, alignTool]
  );
};
